export const PERCENTILE_BADGE_HEIGHT = 19;
export const PERCENTILE_BADGE_WIDTH = 28;
export const PERCENTILE_BADGE_GAP = 2;
export const PERCENTILE_BADGE_STACKED_OFFSET = 4;
export const PERCENTILE_BADGE_X_OFFSET = 2;
export const PERCENTILE_BADGE_HOVER_PADDING = 4;
